export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const GET_CURRENT_REQUEST = 'GET_CURRENT_REQUEST';
export const GET_CURRENT_SUCCESS = 'GET_CURRENT_SUCCESS';
export const GET_CURRENT_ERROR = 'GET_CURRENT_ERROR';
